import { t } from "@/translations"

export function getProductVariantLinkLabel(
    langCode: string,
    name: string,
    colorName?: string | null
): string {
    const trimmedName = name.trim()
    const trimmedColor = colorName?.trim() ?? ""

    if (!trimmedName) return trimmedColor
    if (!trimmedColor || trimmedColor === trimmedName) return trimmedName

    return t(langCode, "product_page.variant_link", {
        name: trimmedName,
        color: trimmedColor
    })
}
